export default "__VITE_ASSET__BsnQgFeV__"